export interface FavoritesView {
  groups?: Array<{ category: string; paths: string[] }>;
  revision: number;
  available: Array<{ path: string; label: string }>;
  favorites: string[];
}
export const navigationPreferenceKey = (
  company?: string,
  user?: string,
  role?: string,
  vertical?: string,
) => ['navigation-favorites', `${company}:${user}:${role}:${vertical}`] as const;

export const canonicalNavigationPath = (path: string) =>
  path.replace(/^\/m\/(crm|atendimento|agenda|conhecimento|automacoes)(?=\/)/, '');

export function favoriteChoices(view: FavoritesView, vertical?: string) {
  const fixed =
    vertical === 'generic'
      ? ['/', '/minha-empresa', '/modulos']
      : [
          '/',
          '/conversas',
          '/contatos',
          '/oportunidades',
          '/agenda',
          '/modulos',
          '/minha-empresa',
          '/assistentes',
          '/automacoes',
          '/resultados',
        ];
  return view.available.filter(
    (item, index, all) =>
      !fixed.includes(canonicalNavigationPath(item.path)) &&
      all.findIndex(
        (other) => canonicalNavigationPath(other.path) === canonicalNavigationPath(item.path),
      ) === index,
  );
}
export function visiblePreferencePaths(view: FavoritesView, vertical?: string) {
  const choices = favoriteChoices(view, vertical);
  return [
    ...new Set(
      view.favorites.flatMap((path) => {
        const item = choices.find(
          (choice) => canonicalNavigationPath(choice.path) === canonicalNavigationPath(path),
        );
        return item ? [item.path] : [];
      }),
    ),
  ];
}
